export default __webpack_public_path__ + "static/seo-ea32a79c878275a9049ee9d27160ad8b.png";